import { trpc } from "@/lib/trpc";
import { Loader2 } from "lucide-react";
import { ServiceOperationsDashboard } from "./ServiceOperationsDashboard";

export function TechnicianDashboardView() {
  const { data, isLoading } = trpc.serviceDashboard.operations.useQuery(undefined, {
    refetchInterval: 20_000,
  });

  if (isLoading || !data) {
    return (
      <div className="flex items-center justify-center py-24 text-slate-500">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" />
        Loading service operations…
      </div>
    );
  }

  return <ServiceOperationsDashboard data={data} />;
}
